<template>
  <div :class="$style.topbar">
    <!-- <div class="mr-md-4 mr-auto">
      <air-search />
    </div>-->
    <div class="mr-auto d-block">
      <!-- <air-issues-history /> -->
      <!-- <a href="javascript: void(0);" :class="$style.air__menuTop__logo">
        <img :src="user.user ? user.user.school ? user.user.school.logo : '/resources/images/air-logo.png' : '/resources/images/air-logo.png'" alt="neoskool" />
        <div :class="$style.air__menuTop__logo__name">{{ user.user ? user.user.school ? user.user.school.name : 'neoskool' : 'neoskool' }}</div>
        <div :class="$style.air__menuTop__logo__descr">{{ user.user ? user.user.school ? 'neoskool - school management' : 'School Management' : 'School Management' }}</div>
      </a> -->
      <a href="javascript: void(0);" class="d-flex mb-1" :class="$style.air__menuTop__logo">
        <div>
          <img :src="user.user ? user.user.school ? user.user.school.logo : '/resources/images/air-logo.png' : '/resources/images/air-logo.png'" alt="neoskool" />
        </div>
        <div class="d-flex flex-column justify-content-center ml-2">
          <div :class="$style.air__menuTop__logo__name">{{ user.user ? user.user.school ? user.user.school.name : 'neoskool' : 'neoskool' }}</div>
          <div :class="$style.air__menuTop__logo__descr">{{ user.user ? user.user.school ? 'neopath - institute management' : 'Institute Management' : 'Institute Management' }}</div>
        </div>
      </a>
    </div>
    <!-- <div class="mb-0 mr-4 d-xl-block d-none">
      <air-status />
    </div>
    <div class="mr-4 d-none d-sm-block">
      <air-language-switcher />
    </div> -->
    <!-- <div class="mr-2 d-none d-sm-block text-right">
      <div :class="$style.neo_username">{{ user.user ? user.user.first_name : '' }} {{ user.user ? user.user.last_name : '' }}</div>
      <div :class="$style.neo_user_role">{{ user.user ? user.user.role : ''}}</div>
    </div> -->
    <div class="mr-2">
      <neo-notification />
    </div>
    <div class>
      <air-user-menu :user="user.user"/>
    </div>
  </div>
</template>

<script>
// import AirSearch from '@/components/layout/TopBar/Search'
// import AirIssuesHistory from '@/components/layout/TopBar/IssuesHistory'
// import AirStatus from '@/components/layout/TopBar/Status'
// import AirLanguageSwitcher from '@/components/layout/TopBar/LanguageSwitcher'
// import AirActions from '@/components/layout/TopBar/Actions'
import AirUserMenu from '@/components/layout/TopBar/UserMenu'
import NeoNotification from '@/components/layout/TopBar/Notification'
import { mapState } from 'vuex'

export default {
  components: {
    // AirSearch,
    // AirIssuesHistory,
    // AirStatus,
    // AirLanguageSwitcher,
    // AirActions,
    AirUserMenu,
    NeoNotification,
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
